import { IsBoolean, IsISO8601, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class CreateCleaningAreaClosurePeriodDto {
  @IsISO8601({ strict: true })
  @IsNotEmpty()
  startDate!: string;

  @IsISO8601({ strict: true })
  @IsNotEmpty()
  endDate!: string;

  @IsString()
  @IsOptional()
  @MaxLength(120)
  label?: string;

  @IsBoolean()
  @IsOptional()
  recurringYearly?: boolean;
}
